import type { ReactNode } from 'react';
import { getCriticality } from '../trackingUtils';
import useMtText from './useMtText';

interface ICriticalityBadgeProps {
    value?: number | string;
    fallback?: ReactNode;
}

const CriticalityBadge = ({ value, fallback = null }: ICriticalityBadgeProps) => {
    const { msg } = useMtText();
    const criticality = getCriticality(value);

    if (!criticality) {
        return <>{fallback}</>;
    }

    return (
        <span className={`mt-crit mt-${criticality.tone}`}>
            <i />
            {msg(criticality.labelId)}
        </span>
    );
};

export default CriticalityBadge;
